import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { AuditLogService } from '../../../services/audit-log.service';
import { NgbNavModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateView } from '../global/create-view/create-view';
import { UpdateView } from '../global/update-view/update-view';
import { TimezonePipe } from '../../../pipes/timezone.pipe';
import { FormsModule } from '@angular/forms';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-profile-edit',
  standalone: true, // ✅ This is required for the imports array to work
  imports: [
    CommonModule,
    NgbNavModule,
    NgbCollapseModule, // ✅ Required for <ngb-accordion> and <ngb-panel>
    CreateView,
    UpdateView,
    TimezonePipe,
    FormsModule
  ],
  templateUrl: './profile-edit.html',
  styleUrls: ['./profile-edit.scss']
})

export class ProfileEdit implements OnInit {
  schoolId: string | null = null;
  model: string = '';
  isLoading = false;

  profileEditData: any[] = [];     // all logs
  createData: any | null = null; // single CREATE
  updatesData: any[] = [];      // multiple UPDATE logs
  activeTab = 1;
  profileEditrenderData: any;
  subscriptionData: any;
  profileEditCreateData: any;
  profileEditUpdateData: any[] = [];
  subscriptionGroupedData: any[] = []; // new structure for UI rendering


  constructor(
    private route: ActivatedRoute,
    private auditLogService: AuditLogService,
    private modalService: NgbModal // <-- Add this
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.schoolId = params['id'] || null;
      this.model = params['action'] || null;
      if (this.schoolId) {
        this.fetchMyListLogs(this.schoolId, this.model);
      }
    });
  }

  async fetchMyListLogs(id: string, action: string): Promise<void> {
    this.isLoading = true;
    try {
      const response: any = await firstValueFrom(
        this.auditLogService.searchById(id, action)
      );

      this.profileEditData = response?.data || [];
      // group by object_id
      const groupedLogs = this.groupBy(this.profileEditData, 'helper_model');
      this.profileEditrenderData = groupedLogs['schoolProfileData'] || [];
      this.subscriptionData = groupedLogs['SchoolSubscription'] || [];
this.processSubscriptionData();

      this.profileEditrenderData.forEach((log: any) => {
        if (log.action === 'CREATE') {
          this.profileEditCreateData = log.new_fields;
        } else if (log.action === 'UPDATE') {
          this.profileEditUpdateData.push(log);
        }
      });

      console.log('Search results:', this.profileEditrenderData);
      console.log('Profile Edit Update Data:', this.subscriptionData);

    } catch (error) {
      console.error('Error during search:', error);
    } finally {
      this.isLoading = false;
    }
  }

  private groupBy(array: any[], key: string): { [key: string]: any[] } {
    return array.reduce((result, current) => {
      const groupKey = current[key] ?? 'schoolProfileData';
      if (!result[groupKey]) {
        result[groupKey] = [];
      }
      result[groupKey].push(current);
      return result;
    }, {} as { [key: string]: any[] });
  }

  onSearch(): void {
    if (this.schoolId) {
      this.fetchMyListLogs(this.schoolId.trim(), this.model);
    }
  }

  openCreateModal(template: TemplateRef<any>) {
    this.modalService.open(template, { size: 'xl' });
  }

  private processSubscriptionData(): void {
    const groupedByHelper = this.groupBy(this.subscriptionData, 'helper_id');

    this.subscriptionGroupedData = Object.keys(groupedByHelper).map(helperId => {
      const logs = groupedByHelper[helperId];
      const createLogs = logs.filter((log: any) => log.action === 'CREATE');
      const updateLogs = logs.filter((log: any) => log.action === 'UPDATE');

      // Find the CREATE log and get its date (assuming 'created_at' field)
      const createDate = createLogs.length > 0 ? createLogs[0].created_at : null;

      return {
        createDate,
        create: createLogs,
        update: updateLogs,
              collapsed: true,       // ✅ Collapse by default
      };
    });

    // Sort by createDate descending
    this.subscriptionGroupedData.sort((a, b) => {
      if (!a.createDate) return 1;
      if (!b.createDate) return -1;
      return new Date(b.createDate).getTime() - new Date(a.createDate).getTime();
    });

    console.log("Processed subscriptionGroupedData:", this.subscriptionGroupedData);
  }
  
}
